import Appsignal from '@appsignal/javascript'
import { plugin } from '@appsignal/plugin-window-events'

let appsignal = { disabled: true }

if (land_tender?.appsignal?.active) {
  appsignal = new Appsignal({
    key: land_tender.appsignal.key,
    revision: land_tender.revision
  })

  // these options are the defaults and listed here so they are explicitly stated
  // https://docs.appsignal.com/front-end/plugins/plugin-window-events.html
  appsignal.use(plugin({ onerror: true, onunhandledrejection: true }))
}

export { appsignal }
